import { Link } from 'react-router-dom';
import './JobCard.scss';

function DemandedJobCard({ img, name, earning, frequency, to }) {
    return (
        <Link to={to} reloadDocument={true}>
        <div className="job-card-wrp" >
            <div className="job-image" >
                <img src={img}  alt="Job type" />
            </div>
            <div className="name-wrp" >
                <div className="type" >{name}</div>
                <div className='earning-wrp'>
                    <div className="earning" >{earning}</div>
                    <div className='frequency'>{frequency}</div>
                </div>
            </div>
        </div></Link>);
}

export default DemandedJobCard;